<template>
  <component class="button-text" :is="url ? AtomicLink : 'span'" :href="url" :targetBlank="targetBlank">
    <slot></slot>
  </component>
</template>

<script setup lang="ts">
  const AtomicLink = resolveComponent('atomic-link');

  defineProps<{
    url?: string;
    targetBlank?: boolean;
  }>();
</script>

<style src="~/assets/styles/components/button/text.scss" lang="scss" />
